// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
//import 'swiper/css/bundle';

var swiper = new Swiper(".slider-feature", {
    navigation: {
        nextEl: '.navbar-next',
        prevEl: '.navbar-prev',
    },
    hashNavigation: {
        watchState: true,
    },
    grabCursor: true,
    slidesPerView: 1,
    effect: "creative",
    creativeEffect: {
        prev: {
            translate: ["-20%", 0, -1],
        },
        next: {
            translate: ["100%", 0, 0],
        },
    },
    on: {
        setTransition: function() {
            themeHeader();
        },
        init: function() {
            themeHeader();
        }
    },
});

function themeHeader() {
    var featureCurrent = $('.swiper-slide-active');
    var dataTheme = featureCurrent.attr('data-theme');
    var globalHeader = $('#siteHeader');

    if (dataTheme == "dark") {
        globalHeader
            .addClass('header-dark')
            .removeClass('header-light');
    } else {
        globalHeader
            .addClass('header-light')
            .removeClass('header-dark');
    }
}
